<template>
    <ProfileDetails/>
</template>

<script>

import { mapState } from 'vuex';
import ProfileDetails from '../../components/ProfileDetails';

export default {
  components: {
    ProfileDetails,
  },
  computed: {
    ...mapState({
      profile: (state) => state.profile.profile,
    }),
  },
};
</script>
